export function galleryMarquee() {
    const marquee = document.querySelector(".gallery-slider__marquee");
    if (!marquee) return;

    // Dupliceer content voor naadloze loop
    marquee.innerHTML += marquee.innerHTML;

    // Breedte van originele content
    const marqueeWidth = marquee.scrollWidth / 3;

    // One-direction infinite marquee
    gsap.to(marquee, {
        x: `-=${marqueeWidth}`,
        duration: 30, // snelheid
        ease: "none",
        repeat: -1,
        modifiers: {
            x: gsap.utils.unitize(x => parseFloat(x) % marqueeWidth)
        }
    });
}
